module.exports = __webpack_public_path__ + "frontend/img/icon_arrow_right.c8797789.svg";